import React from "react";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/pincode-management");
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div className="breadcrumb-title pe-3 mb-3">
          Dashboard
        </div>
        <button
          className="btn btn-primary text-right"
          onClick={handleNavigate}
        >
         Pincode Management
        </button>
       
      </div>
    </>
  );
}

export default Dashboard;
